module.exports = __webpack_public_path__ + "img/train-7.a7b7dfa9.jpg";